import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const NewPhaseDialog = ({ open, onOpenChange, newPhase, setNewPhase, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md border border-zinc-200  rounded-none p-0 max-h-[90vh] overflow-y-auto">
      <DialogHeader className="p-6 pb-0">
        <DialogTitle className="text-2xl font-heading font-bold uppercase tracking-wide">Add Phase</DialogTitle>
      </DialogHeader>

      <form onSubmit={onSubmit} className="p-6 pt-4 space-y-4">
        <div>
          <label className="block text-xs font-bold uppercase tracking-wide mb-2">Phase Name *</label>
          <input
            type="text"
            value={newPhase.name}
            onChange={(e) => setNewPhase({ ...newPhase, name: e.target.value })}
            required
            data-testid="new-phase-name"
            className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
            placeholder="Rough-In"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide mb-2">Start Date</label>
            <input
              type="date"
              value={newPhase.start_date}
              onChange={(e) => setNewPhase({ ...newPhase, start_date: e.target.value })}
              data-testid="new-phase-start"
              className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide mb-2">End Date</label>
            <input
              type="date"
              value={newPhase.end_date}
              onChange={(e) => setNewPhase({ ...newPhase, end_date: e.target.value })}
              data-testid="new-phase-end"
              className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
            />
          </div>
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wide mb-2">Materials Budget</label>
          <input
            type="number"
            value={newPhase.budget}
            onChange={(e) => setNewPhase({ ...newPhase, budget: e.target.value })}
            data-testid="new-phase-budget"
            className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
            placeholder="50000"
          />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wide mb-2">Status</label>
          <select
            value={newPhase.status}
            onChange={(e) => setNewPhase({ ...newPhase, status: e.target.value })}
            className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
          >
            <option value="Not Started">Not Started</option>
            <option value="In Progress">In Progress</option>
            <option value="Complete">Complete</option>
            <option value="Delayed">Delayed</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wide mb-2">Description</label>
          <textarea
            value={newPhase.description}
            onChange={(e) => setNewPhase({ ...newPhase, description: e.target.value })}
            data-testid="new-phase-description"
            className="w-full h-24 border border-zinc-200 bg-white text-zinc-900 p-4 resize-none"
            placeholder="Phase description..."
          />
        </div>
        <div className="flex gap-3 pt-4">
          <button type="button" onClick={() => onOpenChange(false)} className="flex-1 h-10 bg-white text-zinc-900 font-bold uppercase border border-zinc-200">Cancel</button>
          <button type="submit" data-testid="create-phase-btn" className="flex-1 h-10 bg-primary text-zinc-900 font-bold uppercase border border-zinc-200  hover:bg-primary-hover active:translate-y-1">Create</button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
